var map = {
	"./performance_1.svg": "bDuB",
	"./performance_2.svg": "k6Lw",
	"./performance_3.svg": "uYsX",
	"./performance_4.svg": "5MfG",
	"./performance_5.svg": "f5kP",
	"./performance_6.svg": "DTDc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "HVQI";